import {gsap} from "gsap/all";
import $ from "jquery";

export class PinchDetectionHandler {

  constructor({simulate}) {
    this.initialDistance = null;
    this.initialTouchPos = {x: 0, y: 0};
    this.pinchOutThreshold = 100;  // Minimum space between fingers (in px) to trigger the pinch out
    this.pinchInThreshold = 100;  // Minimum space between fingers (in px) to trigger the pinch in

    // If we are not on a multitouch device, we'll simulate a pinch with a gesture instead
    // In simulate mode, we'll detect a simple finger swipe in any direction
    this.simulate = simulate;
    this.ctrlKeyDown = false;
    // Set this to true if you want to see the touch start position and distance on screen
    // Useful if you want to see the nearest face feature for example and or debug the threshold
    this.debug = false;

    this.startTouch = null;

    if (this.simulate) {
      console.warn("We are not on a multitouch device, pinch will be simulated by a swipe.");
    }

    this.init();
  }

  init() {
    // this.addEvents();

    this.resetEvents();

    window.addEventListener("keydown", (e) => (this.keydownHandler(e)));
    window.addEventListener("keyup", (e) => (this.keyupHandler(e)));
  }

  keydownHandler(e) {
    // detect if the ctrl key is pushed
    this.ctrlKeyDown = e.ctrlKey;
    $("#touch-debug-dot").toggleClass("pinchin", this.ctrlKeyDown);
  }

  keyupHandler(e) {
    // Reset the ctrl key detection
    this.ctrlKeyDown = false;
    $("#touch-debug-dot").removeClass("pinchin");
  }

  touchStartHandler(e) {
    // console.log("touch start pinch detection");
    if (this.simulate) {
      this.initialDistance = 0;
      this.startTouch = e.originalEvent.touches[0];
      this.initialTouchPos = {x: this.startTouch.clientX, y: this.startTouch.clientY};

      if (this.debug) {
        $("#touch-debug-dot, #touch-debug-label").show();
        $("#touch-debug-dot, #touch-debug-label").css({left: this.initialTouchPos.x, top: this.initialTouchPos.y})
        $("#touch-debug-label").text(0);
      }

      $(document).off('touchstart.pinchdetection');
      $(document).off('touchmove.pinchdetection').on('touchmove.pinchdetection', (e) => (this.touchMoveHandler(e)));
      $(document).off('touchend.pinchdetection').on('touchend.pinchdetection', (e) => (this.touchEndHandler(e)));
    } else {
      // Only handle if we have more than one touch, because you can't pinch with a single finger
      if (e.originalEvent.touches.length === 2) {
        this.initialDistance = this.getDistance(e.originalEvent.touches);
        this.initialTouchPos = this.getMiddlePoint(e.originalEvent.touches);

        if (this.debug) {
          $("#touch-debug-dot, #touch-debug-label").show();
          $("#touch-debug-dot, #touch-debug-label").css({left: this.initialTouchPos.x, top: this.initialTouchPos.y})
          $("#touch-debug-label").text(0);
        }

        $(document).off('touchstart.pinchdetection');
        $(document).off('touchmove.pinchdetection').on('touchmove.pinchdetection', (e) => (this.touchMoveHandler(e)));
        $(document).off('touchend.pinchdetection').on('touchend.pinchdetection', (e) => (this.touchEndHandler(e)));
      }
    }

  }

  touchMoveHandler(e) {
    // console.log("touch move pinch detection");
    let currentDistance = 0;

    if (this.simulate) {
      currentDistance = this.getDistance([this.startTouch, e.originalEvent.touches[0]]);
    } else {
      if (e.originalEvent.touches.length === 2 && this.initialDistance !== null) {
        currentDistance = this.getDistance(e.originalEvent.touches);
      }
    }

    if (this.debug) {
      $("#touch-debug-label").text((currentDistance - this.initialDistance).toFixed(2));
    }

    if (currentDistance > this.initialDistance) {
      // We are pinching out, wait for threshold
      // Note that in simulate mode, we'll always be here as the distance can't be negative
      if (currentDistance - this.initialDistance > this.pinchOutThreshold) {

        // If we are in simulate mode, we'll trigger a pinchout when threshold is met
        // OR a pinchin if the ctrl key is pressed
        if (this.simulate && this.ctrlKeyDown) {
          $(document).trigger('pinchin', {point: this.initialTouchPos});
        } else {
          $(document).trigger('pinchout', {point: this.initialTouchPos});
        }

        // Stop polling so we do not trigger more than once
        $(document).off('touchmove.pinchdetection');
      }
    } else {
      // We are pinching in, wait for threshold
      if (this.initialDistance - currentDistance > this.pinchInThreshold) {
        $(document).trigger('pinchin', {point: this.initialTouchPos});
        // Stop polling so we do not trigger more than once
        $(document).off('touchmove.pinchdetection');
      }
    }

    // console.log(currentDistance);
  }

  touchEndHandler(e) {
    // console.log("touch end pinch detection");
    if (this.simulate) {
      if (e.originalEvent.touches.length < 1) {
        this.startTouch = null;

        this.resetEvents();
      }
    } else {
      // Clear the pinch if less than 2 fingers are touching
      if (e.originalEvent.touches.length < 2) {
        this.initialDistance = null;

        this.resetEvents();
      }
    }

  }

  getDistance(touches) {
    const [t1, t2] = touches;
    const dx = t2.clientX - t1.clientX;
    const dy = t2.clientY - t1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  getMiddlePoint(touches) {
    const [t1, t2] = touches;
    const midX = (t1.clientX + t2.clientX) / 2;
    const midY = (t1.clientY + t2.clientY) / 2;
    return {x: midX, y: midY}
  }

  resetEvents() {
    if (this.debug) {
      // $("#touch-debug-dot, #touch-debug-label").hide();
    }

    this.initialDistance = null;
    this.initialTouchPos = {x: 0, y: 0};

    $(document).off('touchstart.pinchdetection').on('touchstart.pinchdetection', (e) => (this.touchStartHandler(e)));
    $(document).off('touchmove.pinchdetection');
    $(document).off('touchend.pinchdetection');
  }

  reset() {
    // this.clearEvents();
    // this.addEvents();
  }

}
